(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luggex-preorder-notice"] && !Shopify.designMode) return;
  try {
    (() => {
      if (window.luggexPreorderNoticeBound) return;
      window.luggexPreorderNoticeBound = true;

      const ADD_SELECTOR = [
        'button[name="add"]',
        'button.product-form__submit',
        '[data-add-to-cart]',
        '[data-luggex-checkout-button]',
        '.shopify-payment-button',
        'shopify-accelerated-checkout'
      ].join(',');
      const BUY_ME_CONTINUE = '.lb-popup .lb-button';

      const formElementId = (form) => String(form?.getAttribute?.('id') || '').trim();

      const getVariantId = (form, event) => {
        const fromEvent = event?.detail?.variant?.id;
        if (fromEvent) return String(fromEvent);
        const input = form?.querySelector('[name="id"]');
        return input ? String(input.value) : '';
      };

      const preorderClocks = new WeakMap();
      // A calendar date ends after that full day in the store's time zone.
      const isShipDateExpired = (shipDate, timeZone, now) => {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(shipDate)) return false;
        const parsed = new Date(`${shipDate}T00:00:00Z`);
        if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== shipDate) return false;
        try {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
          }).formatToParts(new Date(now));
          const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
          return `${values.year}-${values.month}-${values.day}` > shipDate;
        } catch (_) {
          return false; // Invalid settings must not prematurely end pre-orders.
        }
      };
      const isPreorderExpired = (root) => {
        if (root.dataset.luggexPreorderAutoExpire !== 'true') return false;
        let clock = preorderClocks.get(root);
        if (!clock) {
          const serverNow = Number(root.dataset.luggexPreorderServerNow) * 1000;
          clock = { now: serverNow > 0 ? serverNow : Date.now(), started: performance.now() };
          preorderClocks.set(root, clock);
        }
        return isShipDateExpired(
          root.dataset.luggexPreorderShipDate || '',
          root.dataset.luggexPreorderTimeZone || 'America/Los_Angeles',
          clock.now + performance.now() - clock.started
        );
      };

      const isMatchForRoot = (root, variantId) => {
        if (isPreorderExpired(root)) return false;
        return String(root.dataset.luggexPreorderIds || '').split(',').includes(String(variantId));
      };

      const getSubmitButtons = (form, formId) => {
        const scoped = form
          ? Array.from(form.querySelectorAll('button[name="add"], button.product-form__submit'))
          : [];
        const associated = Array.from(
          document.querySelectorAll(`button[name="add"][form="${formId}"], button.product-form__submit[form="${formId}"]`)
        );
        return Array.from(new Set(scoped.concat(associated)));
      };

      const getLabelTarget = (button) => {
        return (
          button.querySelector('.luggex-sticky-label') ||
          button.querySelector('.btn-text > span') ||
          button.querySelector('.btn-text')
        );
      };

      const rememberOriginal = (button) => {
        const target = getLabelTarget(button);
        if (!target || target.textContent.trim() === button.dataset.luggexPreorderApplied) return;
        button.dataset.luggexPreorderOriginal = target.textContent.trim();
      };

      const setButtonLabel = (button, label) => {
        rememberOriginal(button);
        const target = getLabelTarget(button);
        if (target) {
          target.textContent = label;
          button.dataset.luggexPreorderApplied = label;
          if (!button.dataset.luggexPreorderAria) button.dataset.luggexPreorderAria = button.getAttribute('aria-label') || '';
          button.setAttribute('aria-label', label);
        }
      };

      const restoreButtonLabel = (button) => {
        const original = button.dataset.luggexPreorderOriginal;
        const target = getLabelTarget(button);
        if (original && target && target.textContent.trim() === button.dataset.luggexPreorderApplied) {
          target.textContent = original;
        }
        if (button.dataset.luggexPreorderAria !== undefined && button.getAttribute('aria-label') === button.dataset.luggexPreorderApplied) {
          button.setAttribute('aria-label', button.dataset.luggexPreorderAria);
        }
        delete button.dataset.luggexPreorderAria;
        delete button.dataset.luggexPreorderOriginal;
        delete button.dataset.luggexPreorderApplied;
      };

      const setRootState = (root, isMatch) => {
        const ack = root.querySelector('[data-luggex-preorder-ack]');
        const ackWrap = root.querySelector('[data-luggex-preorder-ack-wrap]');
        const ackError = root.querySelector('[data-luggex-preorder-error]');
        const properties = root.querySelectorAll('[data-luggex-preorder-property]');

        const editorPreview = root.dataset.luggexPreorderEditor === 'true';
        const previewNote = root.querySelector('[data-luggex-preorder-editor-preview]');
        root.hidden = !isMatch && !editorPreview;
        root.dataset.luggexPreorderActive = String(isMatch);
        if (previewNote) {
          previewNote.hidden = isMatch || !editorPreview;
          previewNote.textContent = isPreorderExpired(root)
            ? 'Pre-order ended automatically. Shoppers now see normal purchase options. Change Ship date to start a new pre-order.'
            : 'Editor preview only. Shoppers see this notice only for matching variants.';
        }
        properties.forEach((input) => {
          input.disabled = !isMatch;
        });

        if (!ack || !ackWrap) return;

        ack.disabled = !isMatch;
        ack.required = isMatch;
        ackWrap.hidden = !isMatch && !editorPreview;

        if (!isMatch) {
          ack.checked = false;
          ack.setCustomValidity('');
          ack.removeAttribute('aria-invalid');
          ackWrap.classList.remove('has-error');
          if (ackError) ackError.hidden = true;
        }
      };

      const blockUpsell = (on) => {
        document.documentElement.classList.toggle('luggex-preorder-block-upsell', on);
      };

      const showAckError = (root) => {
        const ack = root.querySelector('[data-luggex-preorder-ack]');
        const ackWrap = root.querySelector('[data-luggex-preorder-ack-wrap]');
        const ackError = root.querySelector('[data-luggex-preorder-error]');
        const message = root.dataset.luggexPreorderError || 'Please agree before continuing.';
        if (!ack || !ackWrap) return;

        blockUpsell(true);
        ack.setCustomValidity(message);
        ack.setAttribute('aria-invalid', 'true');
        ackWrap.classList.add('has-error');
        if (ackError) {
          ackError.textContent = message;
          ackError.hidden = false;
        }
        root.scrollIntoView({ block: 'center', behavior: 'smooth' });
        window.setTimeout(() => {
          ack.focus({ preventScroll: true });
        }, 100);
      };

      const clearAckError = (root) => {
        const ack = root.querySelector('[data-luggex-preorder-ack]');
        const ackWrap = root.querySelector('[data-luggex-preorder-ack-wrap]');
        const ackError = root.querySelector('[data-luggex-preorder-error]');
        if (!ack || !ackWrap) return;
        blockUpsell(false);
        ack.setCustomValidity('');
        ack.removeAttribute('aria-invalid');
        ackWrap.classList.remove('has-error');
        if (ackError) ackError.hidden = true;
      };

      const syncForm = (formId, event) => {
        const form = document.getElementById(formId);
        if (!form) return null;
        const variantId = getVariantId(form, event);
        if (event?.detail?.variant) delete form.dataset.luggexPreorderPending;
        const roots = document.querySelectorAll(
          `[data-luggex-preorder-root][data-luggex-preorder-form="${formId}"]`
        );
        let activeRoot = null;

        roots.forEach((root) => {
          const isMatch = isMatchForRoot(root, variantId);
          setRootState(root, isMatch);
          if (isMatch && !activeRoot) activeRoot = root;
          const variantProperty = root.querySelector('[data-luggex-preorder-variant-property]');
          if (variantProperty) variantProperty.value = variantId;
        });

        getSubmitButtons(form, formId).forEach((button) => {
          if (activeRoot && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
            setButtonLabel(button, activeRoot.dataset.luggexPreorderButton || 'PRE-ORDER');
          } else {
            restoreButtonLabel(button);
          }
        });

        if (!activeRoot) blockUpsell(false);
        return activeRoot;
      };

      const resolveForm = (node) => {
        if (!node) return null;
        if (node.form) return document.getElementById(node.form.dataset.luggexPreorderPrimaryForm) || node.form;
        const formId = node.getAttribute?.('form');
        if (formId) {
          const form = document.getElementById(formId);
          return document.getElementById(form?.dataset.luggexPreorderPrimaryForm) || form;
        }
        return node.closest?.('form') || node.closest?.('.product-form-wrapper')?.querySelector('form');
      };

      const activeFormId = (node) => {
        const fromNode = formElementId(resolveForm(node));
        if (fromNode) return fromNode;
        const root = Array.from(document.querySelectorAll('[data-luggex-preorder-root]')).find((item) => item.dataset.luggexPreorderActive === 'true');
        return root?.dataset.luggexPreorderForm || '';
      };

      const ensureAcknowledged = (formId, event) => {
        const form = document.getElementById(formId);
        if (form?.dataset.luggexPreorderPending === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return false;
        }
        const activeRoot = syncForm(formId, event);
        if (!activeRoot) return true;
        const ack = activeRoot.querySelector('[data-luggex-preorder-ack]');
        if (!ack || ack.checked) {
          clearAckError(activeRoot);
          return true;
        }
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        showAckError(activeRoot);
        return false;
      };

      const bindForm = (formId) => {
        const form = document.getElementById(formId);
        if (!form || form.dataset.luggexPreorderBound === 'true') return;
        form.dataset.luggexPreorderBound = 'true';

        form.addEventListener('variant:change', (event) => {
          window.setTimeout(() => syncForm(formId, event), 0);
        });
        form.addEventListener(
          'submit',
          (event) => {
            ensureAcknowledged(formId, event);
          },
          true
        );
        form.addEventListener('change', () => {
          window.setTimeout(() => syncForm(formId), 0);
        });
      };

      const initAll = () => {
        const roots = document.querySelectorAll('[data-luggex-preorder-root]');
        const formIds = new Set();
        roots.forEach((root) => {
          const formId = root.dataset.luggexPreorderForm;
          if (!formId) return;
          formIds.add(formId);
          const ack = root.querySelector('[data-luggex-preorder-ack]');
          ack?.addEventListener('change', () => {
            if (ack.checked) clearAckError(root);
            syncForm(formId);
          });
        });
        formIds.forEach((formId) => {
          bindForm(formId);
          syncForm(formId);
        });
        watchUpsell();
      };

      const onAddIntent = (event) => {
        if (event.target.closest?.('[data-luggex-preorder-root]')) return;
        if (event.target.closest?.('.lb-popup-cont-action-close')) return;
        const trigger = event.target.closest?.(`${ADD_SELECTOR},${BUY_ME_CONTINUE}`);
        if (!trigger) return;
        const formId = activeFormId(trigger);
        if (!formId) return;
        if (!document.querySelector(`[data-luggex-preorder-root][data-luggex-preorder-form="${formId}"]`)) {
          return;
        }
        ensureAcknowledged(formId, event);
      };

      const watchUpsell = () => {
        if (window.luggexPreorderUpsellWatch) return;
        window.luggexPreorderUpsellWatch = true;
        const tick = () => {
          const root = Array.from(document.querySelectorAll('[data-luggex-preorder-root]')).find((item) => item.dataset.luggexPreorderActive === 'true');
          if (!root) return;
          const ack = root.querySelector('[data-luggex-preorder-ack]');
          if (!ack || ack.checked || ack.disabled) return;
          const popup = document.querySelector('.lb-popup');
          if (!popup) return;
          const box = popup.getBoundingClientRect();
          if (box.height < 80 || getComputedStyle(popup).display === 'none') return;
          showAckError(root);
        };
        new MutationObserver(tick).observe(document.documentElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      };

      document.addEventListener('submit', (event) => {
        const primary = event.target?.dataset?.luggexPreorderPrimaryForm;
        if (primary) ensureAcknowledged(primary, event);
      }, true);
      document.addEventListener('click', onAddIntent, true);
      document.addEventListener('pointerdown', onAddIntent, true);

      document.addEventListener('variant:change', (event) => {
        const form = event.target?.closest?.('form') || event.target;
        const formId = formElementId(form) || document.querySelector('[data-luggex-preorder-root]')?.dataset.luggexPreorderForm;
        if (!formId) return;
        window.setTimeout(() => syncForm(formId, event), 0);
      });

      document.addEventListener('change', (event) => {
        if (!event.target?.matches?.('[data-option-value], [name="id"], variant-picker input')) return;
        document.querySelectorAll('[data-luggex-preorder-root]').forEach((root) => {
          const form = document.getElementById(root.dataset.luggexPreorderForm);
          if (form && event.target.matches('[data-option-value], variant-picker input')) {
            const scope = form.closest('product-info') || form.closest('.shopify-section');
            if (scope?.contains(event.target)) form.dataset.luggexPreorderPending = 'true';
          }
          window.setTimeout(() => syncForm(root.dataset.luggexPreorderForm), 0);
        });
      });

      const refreshExpiry = () => {
        const formIds = new Set(Array.from(document.querySelectorAll('[data-luggex-preorder-root]'))
          .map(root => root.dataset.luggexPreorderForm).filter(Boolean));
        formIds.forEach(formId => syncForm(formId));
      };
      // Also expire tabs left open across midnight, without requiring a reload.
      window.setInterval(() => {
        if (document.visibilityState !== 'hidden') refreshExpiry();
      }, 30000);
      window.addEventListener('pageshow', refreshExpiry);
      document.addEventListener('visibilitychange', refreshExpiry);
      document.addEventListener('shopify:section:load', initAll);
      document.addEventListener('product-info:loaded', () => window.setTimeout(initAll, 0));
      const editorRootForEvent = (event) => {
        const direct = event.target?.closest?.('[data-luggex-preorder-root]');
        if (direct) return direct;
        const blockId = String(event.detail?.blockId || '');
        if (!blockId) return null;
        return Array.from(document.querySelectorAll('[data-luggex-preorder-root]')).find((root) => {
          const rootId = root.dataset.luggexPreorderBlockId;
          return rootId && (blockId === rootId || blockId.endsWith(`__${rootId}`));
        });
      };
      document.addEventListener('shopify:block:select', (event) => {
        const root = editorRootForEvent(event);
        if (!root || root.dataset.luggexPreorderEditor !== 'true') return;
        syncForm(root.dataset.luggexPreorderForm);
      }, true);
      document.addEventListener('shopify:block:deselect', (event) => {
        const root = editorRootForEvent(event);
        if (!root || root.dataset.luggexPreorderEditor !== 'true') return;
        syncForm(root.dataset.luggexPreorderForm);
      }, true);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll, { once: true });
      } else {
        initAll();
      }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luggex-purchase-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luggex-purchase-ui')) {
    customElements.define('luggex-purchase-ui', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        if ([...document.querySelectorAll('luggex-purchase-ui')].some((el) => el !== this && el.ready)) return;
        if (typeof ResizeObserver !== 'function' || typeof MutationObserver !== 'function' || typeof AbortController !== 'function') return;
        this.ready = true;
        this.frame = 0;
        this.retries = 0;
        this.motionUntil = 0;
        this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`) || this.closest('.shopify-section');
        this.abort = new AbortController();
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => this.update());
        };
        const passive = { passive: true, signal: this.abort.signal };
        window.addEventListener('scroll', this.schedule, passive);
        window.addEventListener('resize', this.schedule, passive);
        window.addEventListener('pageshow', this.schedule, passive);
        document.addEventListener('visibilitychange', this.schedule, passive);
        document.addEventListener('focusin', this.schedule, passive);
        document.addEventListener('focusout', this.schedule, passive);
        document.addEventListener('variant:change', this.schedule, passive);
        document.addEventListener('transitionrun', (event) => {
          if (!event.target.matches || !event.target.matches('.mobile-dock, .header')) return;
          const durations = getComputedStyle(event.target).transitionDuration.split(',').map((value) => parseFloat(value) * (value.trim().endsWith('ms') ? 1 : 1000));
          this.motionUntil = performance.now() + Math.min(1500, Math.max(0, ...durations) + 50);
          this.schedule();
        }, passive);
        document.addEventListener('transitionend', this.schedule, passive);
        document.addEventListener('transitioncancel', this.schedule, passive);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', this.schedule, passive);
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.observer = new MutationObserver((records) => {
          const selectors = '.luggex-sticky-purchase, .mobile-dock, .footer-group, #s-chat-plugin, #pop-convert-app, #buy-me';
          const relevant = records.some((record) => {
            if (this.section && this.section.contains(record.target)) return true;
            if (record.target.closest && record.target.closest(selectors)) return true;
            return [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (node.matches(selectors) || node.querySelector(selectors)));
          });
          if (relevant) this.schedule();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.retryOptionalWidgets();
        this.schedule();
      }

      findOptionalWidgets() {
        if (!this.isConnected) return;
        const host = document.getElementById('pop-convert-app');
        const root = host && host.shadowRoot;
        if (root && !root.getElementById('luggex-pdp-social-proof-hidden')) {
          const style = document.createElement('style');
          style.id = 'luggex-pdp-social-proof-hidden';
          style.textContent = '.proof-container,.social-pop{display:none!important;visibility:hidden!important;pointer-events:none!important}';
          root.append(style);
          this.proofStyle = style;
        }
        const chat = document.getElementById('s-chat-plugin');
        if (chat && chat !== this.chat) {
          if (this.chat) this.resizeObserver.unobserve(this.chat);
          if (this.chatAttrObserver) this.chatAttrObserver.disconnect();
          this.chat = chat;
          this.resizeObserver.observe(chat);
          if (!this.chatAttrObserver) this.chatAttrObserver = new MutationObserver(this.schedule);
          this.chatAttrObserver.observe(chat, { attributes: true, attributeFilter: ['style', 'class'] });
        }
        return !!(root && chat);
      }

      retryOptionalWidgets() {
        if (!this.isConnected) return;
        const ready = this.findOptionalWidgets();
        if (!ready && this.retries < 40) {
          this.retries += 1;
          this.retryTimer = setTimeout(() => {
            this.retryOptionalWidgets();
            this.schedule();
          }, 500);
        }
      }

      observeSize(element, key) {
        if (this[key] === element) return;
        if (this[key]) this.resizeObserver.unobserve(this[key]);
        this[key] = element;
        if (element) this.resizeObserver.observe(element);
      }

      setPixels(name, value) {
        const next = `${Math.max(0, Math.ceil(value))}px`;
        if (document.documentElement.style.getPropertyValue(name) !== next) {
          document.documentElement.style.setProperty(name, next);
        }
      }

      coordinateSticky(sticky, card) {
        if (sticky && !sticky.__luggexCoordinated) {
          sticky.__luggexCoordinated = true;
          sticky.handleIntersection = () => {};
        }
        if (!card) return;
        for (const prop of ['opacity', 'visibility', 'transform']) card.style.removeProperty(prop);
      }

      bindStickySubmit(sticky, form) {
        const button = sticky && sticky.querySelector('button[name="add"]');
        if (!button || !form || button.__luggexSubmitBound) return;
        button.__luggexSubmitBound = true;
        button.addEventListener('click', (event) => {
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
          event.preventDefault();
          if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      }

      chatNodes() {
        return [this.chat, document.getElementById('ss-chat-p')].filter((node, index, list) => node && node.isConnected && list.indexOf(node) === index);
      }

      paintChatBlack() {
        const root = document.getElementById('s-chat-code') || document.getElementById('ss-chat-wrapper');
        if (root) {
          root.style.setProperty('--theme-normal', '#111111');
          root.style.setProperty('--theme-normal-rgb', '17, 17, 17');
          root.style.setProperty('--theme-hover', '#333333');
          root.style.setProperty('--theme-active', '#000000');
          root.style.setProperty('--theme-accent', '#111111');
          root.style.setProperty('--theme-bg-accent', '#111111');
        }
        const frame = document.getElementById('s-chat-plugin');
        const doc = frame && frame.contentDocument;
        if (!doc || !doc.documentElement) return;
        if (!doc.getElementById('luggex-chat-black')) {
          const style = doc.createElement('style');
          style.id = 'luggex-chat-black';
          style.textContent = '[class*="Expand_icon__wrap"]{background:#111111!important;background-color:#111111!important}';
          (doc.head || doc.documentElement).append(style);
        }
      }

      pinChat(occupied) {
        const right = 'max(12px, env(safe-area-inset-right, 0px))';
        const bottom = `calc(${Math.max(0, Math.ceil(occupied))}px + 12px)`;
        const next = { position: 'fixed', right, left: 'auto', top: 'auto', bottom, transform: 'none' };
        for (const chat of this.chatNodes()) {
          for (const [prop, value] of Object.entries(next)) {
            if (chat.style.getPropertyValue(prop) !== value) chat.style.setProperty(prop, value, 'important');
          }
        }
        this.paintChatBlack();
      }

      unpinChat() {
        for (const chat of this.chatNodes()) {
          const right = chat.style.getPropertyValue('right');
          const bottom = chat.style.getPropertyValue('bottom');
          const inset = chat.style.getPropertyValue('inset');
          if (right === '12px' || right.startsWith('max(12px')) chat.style.removeProperty('right');
          if (bottom === '12px' || bottom.startsWith('calc(')) chat.style.removeProperty('bottom');
          if (inset.includes('max(12px') || inset.includes('calc(')) chat.style.removeProperty('inset');
          if (chat.style.getPropertyValue('transform') === 'none') chat.style.removeProperty('transform');
          if (chat.style.getPropertyValue('left') === 'auto') chat.style.removeProperty('left');
          if (chat.style.getPropertyValue('top') === 'auto') chat.style.removeProperty('top');
        }
      }

      overlap(a, b) {
        return !!(a && b && a.right > b.left && a.left < b.right && a.bottom > b.top && a.top < b.bottom);
      }

      clearance(occupied, rect) {
        if (!rect || rect.width < 8 || rect.height < 8) return occupied;
        if (rect.bottom <= 0 || rect.top >= innerHeight) return occupied;
        const gap = 12;
        const box = {
          left: 12,
          right: 132,
          top: innerHeight - occupied - gap - 100,
          bottom: innerHeight - occupied - gap
        };
        if (!this.overlap(box, rect)) return occupied;
        return Math.max(occupied, innerHeight - rect.top);
      }

      raiseForBuy(occupied, inlineAdd) {
        const nodes = [];
        if (inlineAdd) nodes.push(inlineAdd.closest('.product-form__buttons, .buy-buttons') || inlineAdd);
        const qty = document.querySelector('quantity-input');
        if (qty) nodes.push(qty);
        document.querySelectorAll('[data-luggex-sticky-shop]').forEach((node) => nodes.push(node));
        const checkout = document.querySelector('button[name="checkout"]');
        if (checkout && checkout.offsetParent && getComputedStyle(checkout).visibility !== 'hidden') nodes.push(checkout);
        let next = occupied;
        for (const node of nodes) next = this.clearance(next, node.getBoundingClientRect());
        return next;
      }

      update() {
        this.frame = 0;
        if (!this.isConnected) return;
        const html = document.documentElement;
        html.setAttribute('data-luggex-pdp-ui', '');
        const sticky = document.querySelector('.luggex-sticky-purchase');
        if (sticky) this.section = sticky.closest('.shopify-section') || this.section;
        const card = sticky && sticky.firstElementChild;
        const form = sticky && document.getElementById(sticky.getAttribute('form'));
        this.coordinateSticky(sticky, card);
        this.bindStickySubmit(sticky, form);
        this.observeSize(card, 'card');
        this.observeSize(form, 'observedForm');
        this.observeSize(document.querySelector('.page-container'), 'pageContainer');
        const dock = document.querySelector('.mobile-dock');
        this.observeSize(dock, 'dock');
        const dockRect = dock && dock.getBoundingClientRect();
        const dockVisible = innerWidth < 768 && dockRect && getComputedStyle(dock).display !== 'none' && dockRect.top < innerHeight && dockRect.bottom > 0;
        const dockOffset = dockVisible ? Math.min(dockRect.height, Math.max(0, innerHeight - dockRect.top)) : 0;
        this.setPixels('--luggex-dock-offset', dockOffset);
        const editing = document.activeElement && document.activeElement.matches('input, textarea, select, [contenteditable="true"]');
        const keyboardOpen = innerWidth < 768 && editing && window.visualViewport && window.visualViewport.height < innerHeight - 150;
        const inlineAdd = form && [...form.querySelectorAll('button[name="add"]')].find((button) => !button.closest('.luggex-sticky-purchase'));
        const trigger = inlineAdd || form;
        const triggerRect = trigger && trigger.getBoundingClientRect();
        const visibleBottom = innerHeight - dockOffset;
        const addOnScreen = !!(triggerRect && triggerRect.bottom > 12 && triggerRect.top < visibleBottom - 12);
        const active = !!(sticky && trigger && !addOnScreen && !keyboardOpen && !document.hidden);
        html.toggleAttribute('data-luggex-purchase-managed', !!(sticky && form));
        html.toggleAttribute('data-luggex-bar-on', active);
        if (sticky) sticky.toggleAttribute('data-bar-visible', active);
        if (card) {
          if (!active && card.contains(document.activeElement)) {
            const focused = document.activeElement;
            if (focused && focused.blur) focused.blur();
            const bounds = form && form.getBoundingClientRect();
            if (bounds && bounds.top >= 0 && bounds.bottom <= innerHeight) {
              const button = form.querySelector('[name="add"], [type="submit"]');
              if (button) button.focus({ preventScroll: true });
            }
          }
          card.toggleAttribute('inert', !active);
          card.setAttribute('aria-hidden', String(!active));
        }
        let occupied = dockOffset;
        if (active && card) {
          const cardRect = card.getBoundingClientRect();
          occupied = cardRect.top > 0 && cardRect.top < innerHeight
            ? Math.max(dockOffset, innerHeight - cardRect.top)
            : dockOffset + cardRect.height;
        }
        const legacyBuyMe = document.getElementById('buy-me');
        this.observeSize(legacyBuyMe, 'legacyBuyMe');
        const legacyRect = legacyBuyMe && legacyBuyMe.getBoundingClientRect();
        if (innerWidth < 768 && legacyRect && legacyRect.width > 0 && legacyRect.height > 0 &&
            getComputedStyle(legacyBuyMe).display !== 'none' && getComputedStyle(legacyBuyMe).visibility !== 'hidden' &&
            Number(getComputedStyle(legacyBuyMe).opacity) > .05 && legacyRect.bottom >= innerHeight - dockOffset - 2 && legacyRect.top < innerHeight) {
          occupied = Math.max(occupied, innerHeight - Math.max(0, legacyRect.top));
        }
        this.findOptionalWidgets();
        this.paintChatBlack();
        if (this.chat && this.chat.isConnected) {
          const rect = this.chat.getBoundingClientRect();
          const bubble = rect.width > 0 && rect.width <= 180 && rect.height > 0 && rect.height <= 220;
          if (bubble) occupied = this.raiseForBuy(occupied, inlineAdd);
          this.chat.toggleAttribute('data-luggex-chat-bubble', bubble);
          if (bubble) this.pinChat(occupied);
          else this.unpinChat();
        }
        const barHeight = active && card ? card.getBoundingClientRect().height : 0;
        this.setPixels('--luggex-bar-height', barHeight);
        this.setPixels('--luggex-occupied-bottom', occupied);
        if (performance.now() < this.motionUntil) this.schedule();
      }

      disconnectedCallback() {
        this.ready = false;
        if (this.abort) this.abort.abort();
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.chatAttrObserver) this.chatAttrObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.retryTimer);
        if (this.chat) {
          this.unpinChat();
          this.chat.removeAttribute('data-luggex-chat-bubble');
        }
        if (this.proofStyle) this.proofStyle.remove();
        const html = document.documentElement;
        html.removeAttribute('data-luggex-pdp-ui');
        html.removeAttribute('data-luggex-purchase-managed');
        html.removeAttribute('data-luggex-bar-on');
        for (const name of ['--luggex-occupied-bottom', '--luggex-dock-offset', '--luggex-bar-height']) html.style.removeProperty(name);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
